import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--small",
  "use": "icon-arrow--small-usage",
  "viewBox": "0 0 5 9",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 5 9\" id=\"icon-arrow--small\"><path d=\"M5 4.047.952 0 0 .952 3.098 4.05 0 7.143l.952.952L5 4.047Z\" fill=\"#1C2646\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol